// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let PageViews = require("../../reason/PageViews.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let TemporalPolyfill = require("temporal-polyfill");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UpgradePlanWarning__Jsx3 = require("../../reason/common/UpgradePlanWarning__Jsx3.bs.js");
let ShowingsPageRelayQuery_graphql = require("../../__generated__/ShowingsPageRelayQuery_graphql.bs.js");
let ShowingsPageRelayShowingsByDay = require("./ShowingsPageRelayShowingsByDay.bs.js");
let ShowingsPageRelay_showing_graphql = require("../../__generated__/ShowingsPageRelay_showing_graphql.bs.js");

let convertFragment = ShowingsPageRelay_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ShowingsPageRelay_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

let ShowingFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShowingsPageRelay$ShowingsComponent(props) {
  let showings = RescriptRelay_Fragment.useFragment(ShowingsPageRelay_showing_graphql.node, convertFragment, props.showings);
  let userHasPropertyDetailsFeature = UserSession.useHasPlanFeature("PROPERTY_DETAILS");
  let showingsByDay = Object.entries(Stdlib_Array.reduce(showings, {}, (dict, showing) => {
    let startDate = showing.startDateV2;
    if (startDate === undefined) {
      return dict;
    }
    let day = Primitive_option.valFromOption(startDate).toPlainDate().toString();
    let arr = dict[day];
    let newArrForDay = arr !== undefined ? (arr.push(showing), arr) : [showing];
    dict[day] = newArrForDay;
    return dict;
  }));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      userHasPropertyDetailsFeature ? null : JsxRuntime.jsx(View__Jsx3.make, {
          mb: "md",
          children: JsxRuntime.jsx(UpgradePlanWarning__Jsx3.PropertyDetails.make, {})
        }),
      showingsByDay.map(param => {
        let date = param[0];
        let plainDayMonth = TemporalPolyfill.Temporal.PlainDate.from(date);
        return JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ShowingsPageRelayShowingsByDay.make, {
            date: plainDayMonth,
            showings: param[1].map(s => s.fragmentRefs)
          }),
          className: "my-6"
        }, date);
      })
    ]
  });
}

let ShowingsComponent = {
  ShowingFragment: ShowingFragment,
  make: ShowingsPageRelay$ShowingsComponent
};

let convertVariables = ShowingsPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = ShowingsPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ShowingsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, ShowingsPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ShowingsPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ShowingsPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(ShowingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ShowingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ShowingsPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ShowingsPageRelay$Page(props) {
  let currentUserRole = AuthSession.useCurrentUserRole();
  let data = use$1(undefined, undefined, undefined, undefined);
  let tmp;
  tmp = currentUserRole === "AGENT" ? JsxRuntime.jsx(PageViews.RecordPageView.make, {
      page: PageViews.Page.makeShowingsPage()
    }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Upcoming showings"
      }),
      tmp,
      JsxRuntime.jsx(MarkupHelpers.Container.make, {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(PageUITitle.make, {
              title: "Upcoming showings"
            }),
            JsxRuntime.jsx(ShowingsPageRelay$ShowingsComponent, {
              showings: Stdlib_Array.keepSome(data.upcomingShowingsV5.edges).map(edge => edge.node.fragmentRefs)
            })
          ],
          className: "bg-white p-5 shadow rounded"
        })
      })
    ]
  });
}

let Page = {
  make: ShowingsPageRelay$Page
};

function ShowingsPageRelay$ErrorState(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: "There was a problem loading your chapter's showings. Please refresh or try again later..."
    })
  });
}

let ErrorState = {
  make: ShowingsPageRelay$ErrorState
};

function ShowingsPageRelay$LoadingState(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Loader.make, {}),
    className: "flex justify-center items-center grow h-full"
  });
}

let LoadingState = {
  make: ShowingsPageRelay$LoadingState
};

function ShowingsPageRelay$default(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(ShowingsPageRelay$ErrorState, {}),
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
        loaderComponent: JsxRuntime.jsx(ShowingsPageRelay$LoadingState, {}),
        children: JsxRuntime.jsx(ShowingsPageRelay$Page, {})
      }),
      fallback: JsxRuntime.jsx(ShowingsPageRelay$LoadingState, {})
    }),
    onError: error => Sentry.captureException(error, "ShowingsPageRelay.res", undefined, undefined, undefined)
  });
}

let $$default = ShowingsPageRelay$default;

exports.ShowingsComponent = ShowingsComponent;
exports.Query = Query;
exports.Page = Page;
exports.ErrorState = ErrorState;
exports.LoadingState = LoadingState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
